import { ConversationListItem } from "./ConversationListItem";
import { FleetrifyButton } from "../../Button/customButton";
import { fleetrifyIcons } from "../../../assets/icons/icons";
// import { FleetrifyDropdownToggle } from "../../Dropdown/SelectDrop/customActionDrop";
import { useMessageControllers } from "../../../controllers/useMessagesControllers";
import StartConversation from "./StartConversation";
import { useState, useMemo, useEffect } from "react";
import {
  useGetMyMessagesQuery,
  useMarkAllAsReadMutation,
} from "../../../redux/services/messageApi";

interface Conversation {
  id: string;
  name: string;
  lastMessage: string;
  lastMessageTimestamp: string | number;
  unreadCount: number;
  profilePic?: string;
  user?: any; // ✅ full sender object
}

export const ConversationsSidebar: React.FC<{
  conversations?: Conversation[];
  selectedConversationId: string | null;
  onSelectConversation: (id: string) => void;
  loading?: boolean;
  onSelectDetails?: (param: any) => void;
}> = ({
  conversations: conversationsProp,
  selectedConversationId,
  onSelectConversation,
  loading,
  onSelectDetails,
}) => {
  const [showStartConversation, setShowStartConversation] = useState(false);
  const { chatOptions, chatType, showAddChat, handleShowAddChat } =
    useMessageControllers();
  const [activeTab, setActiveTab] = useState("all");
  const [search, setSearch] = useState("");
  const { data, isLoading } = useGetMyMessagesQuery({
    status:
      activeTab === "read"
        ? "read"
        : activeTab === "unread"
        ? "unread"
        : activeTab === "newest"
        ? "new"
        : "all",
    user_type: "client",
    search,
  });
  const [activeConversationId, setActiveConversationId] = useState<
    string | null
  >(selectedConversationId);

  const [markAllAsRead] = useMarkAllAsReadMutation();

  // Handle tab selection
  const handleTabClick = (tab: string) => {
    setActiveTab(tab); // Update the active tab state
  };
const myId = localStorage.getItem("userId");

const conversations = useMemo<Conversation[]>(() => {
  if (!data?.data?.data || !myId) return [];

  const map = new Map<string, Conversation & { _time: number }>();

  data.data.data.forEach((msg: any) => {
    const isMine = String(msg.sender_id) === myId;

    // ✅ ALWAYS resolve the other user
    const otherUser = isMine ? msg.receiver : msg.sender;
    if (!otherUser) return;

    const time = new Date(msg.created_at).getTime();
    const existing = map.get(String(otherUser.id));

    if (!existing || time > existing._time) {
      map.set(String(otherUser.id), {
        id: String(otherUser.id),
        name: otherUser.name,
        lastMessage: msg.message || "📎 Attachment",
        lastMessageTimestamp: new Date(time).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        unreadCount: !msg.read_at && !isMine ? 1 : 0,
        profilePic: otherUser.profile_image,
        user: otherUser,
        _time: time,
      });
    } else {
      // only count unread messages that are NOT mine
      if (!msg.read_at && !isMine) {
        existing.unreadCount += 1;
      }
    }
  });

  return Array.from(map.values())
    .sort((a, b) => b._time - a._time)
    .map(({ _time, ...rest }) => rest);
}, [data, myId]);

  useEffect(() => {
    setActiveConversationId(selectedConversationId);
  }, [selectedConversationId]);

  return (
    <>
      {showStartConversation ? (
        // ✅ Show StartConversation component
        <StartConversation
          onBack={() => setShowStartConversation(false)}
          onSelectDetails={onSelectDetails ?? ((staff: any) => {})}
        />
      ) : (
        <div className=" bg-[#fff] h-full">
          <div className=" border-b border-gray-300">
            <div className="flex justify-between items-center bg-[#E7EBF3] p-4">
              <div className="flex gap-3 items-center">
                <div className="bg-[#14388733] rounded-[4px] h-[40px] w-[40px] grid place-items-center">
                  <figure>{fleetrifyIcons.houseIcon}</figure>
                </div>
                <h2 className="text-[13px] font-bold text-[#143887]">
                  {chatType}
                </h2>
              </div>
              {/* <FleetrifyDropdownToggle
                options={chatOptions}
                selected={chatType}
              >
                <button>{fleetrifyIcons.ellipseIcon}</button>
              </FleetrifyDropdownToggle> */}
            </div>
            <div className="p-4">
              <FleetrifyButton
                type="button"
                className="w-full focus:outline-none"
                onClick={() => setShowStartConversation(true)}
              >
                <div className="flex gap-2 items-center">
                  <figure>{fleetrifyIcons.conversePlusIcon}</figure>
                  Start conversation
                </div>
              </FleetrifyButton>
              {/* Tab Buttons */}
              <div className="flex gap-6 mt-6 border-b border-gray-200">
                <button
                  onClick={() => handleTabClick("all")}
                  className={`${
                    activeTab === "all"
                      ? "text-[#143887] font-semibold border-b-2 border-[#143887]"
                      : "text-gray-400"
                  } pb-2`}
                >
                  All
                </button>
                <button
                  onClick={() => handleTabClick("newest")}
                  className={`${
                    activeTab === "newest"
                      ? "text-[#143887] font-semibold border-b-2 border-[#143887]"
                      : "text-gray-400"
                  } pb-2`}
                >
               New
                </button>
                <button
                  onClick={() => handleTabClick("read")}
                  className={`${
                    activeTab === "read"
                      ? "text-[#143887] font-semibold border-b-2 border-[#143887]"
                      : "text-gray-400"
                  } pb-2`}
                >
                  Read
                </button>
                {/* <button
                  onClick={() => handleTabClick("archive")}
                  className={`${
                    activeTab === "archive"
                      ? "text-[#143887] font-semibold border-b-2 border-[#143887]"
                      : "text-gray-400"
                  } pb-2`}
                >
                  Archive
                </button> */}
              </div>

              <div className="grid relative mt-4 place-items-center">
                <input
                  type="text"
                  placeholder={`Search ${chatType}`}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full text-sm pl-7 py-3 rounded-[30px] border border-gray-300"
                />
                <figure className="absolute right-6">
                  {fleetrifyIcons.filterSearchIcon}
                </figure>
              </div>
            </div>
          </div>
          <div className="overflow-y-auto px-2">
            {isLoading &&
              Array.from({ length: 4 }).map((_, i) => (
                <ConversationListItem key={i} loading />
              ))}

            {!isLoading &&
              conversations.map((conversation) => (
                <ConversationListItem
                  key={conversation.id}
                  conversation={conversation}
                  isSelected={conversation.id === activeConversationId}
                  onSelect={() => {
                    setActiveConversationId(conversation.id); // 🔒 lock active UI
                    onSelectConversation(conversation.id);
                    onSelectDetails?.(conversation.user);
                    markAllAsRead({ receiver_id: conversation.id });
                  }}
                />
              ))}
          </div>
        </div>
      )}
      {/* <------ add conversation modal -----> */}
      {/* <AddChatModal
        isModalOpen={showAddChat}
        setIsModalOpen={handleShowAddChat}
      /> */}
    </>
  );
};
